export default __webpack_public_path__ + "static/kristoffer2-99983256e534e7a21a73c88fd913d878.png";